<style lang="scss" scoped>
	.contianer {
		width: 100%;
		height: 1190px;
		box-sizing: border-box;
		text-align: center;
	}
	.characteristic-title {
		margin-top: 160px;
		margin-bottom: 60px;
	}
	.characteristic-content {
		position: relative;
		width: 1279px;
		height: 607px;
		margin: 0 auto;
		background: url('../../assets/pc/characteristic-bg.png');
		text-align: center;
	}
	.characteristic-icon1 {
		position: absolute;
		left: -145px;
    	bottom: 100px;
	}
	.characteristic-icon2 {
		position: absolute;
		right: -250px;
    	top: 260px;
	}
	.left {
		position: absolute;
		top: 260px;
		left: 30px;
		cursor: pointer;
	}
	.right {
		position: absolute;
		top: 260px;
		right: 30px;
		cursor: pointer;
	}
	.banner {
		position: relative;
		top: -5px;
		width: 1076px;
		height: 609px;
	}
	.slide-fade-enter-active {
		transition: all 2s ease;
	}
	.slide-fade-enter {
		opacity: 0;
	}
</style>

<template>
  <div class="p-characteristic pc-common-bg">
		<div class="contianer">
			<img class="characteristic-title" src="../../assets/pc/characteristic-title.png" alt="">
			<div class="characteristic-content">
				<img class="characteristic-icon1" src="../../assets/pc/characteristic-icon1.png" alt="">
				<img class="characteristic-icon2" src="../../assets/pc/characteristic-icon2.png" alt="">
				<img class="left" @click="goPreview" @mousemove="clearInterval" @mouseout="interval" src="../../assets/pc/left.png" alt="">
				<img class="right" @click="goNext" @mousemove="clearInterval" @mouseout="interval" src="../../assets/pc/right.png" alt="">
				<template v-for="(item, index) in bannerList" >
					<transition name="slide-fade" :key="index" >
						<img 
							v-show="numberChoose == index" 
							@mousemove="clearInterval" 
							@mouseout="interval" 
							:src="item.filePath" 
							class="banner"
						>
					</transition>
				</template>
			</div>
		</div>
		<p-footer></p-footer>
	</div>
</template>

<script>
import Footer from '../../components/Footer'
export default {
	name: 'p-characteristic',
	components: {
		'p-footer': Footer
	},
	data() {
		return {
			bannerList: [],
			numberChoose: 0,
			timeInterval: null
		}
	},
	mounted() {
		const width = document.body.clientWidth;
		if(width < 850) {
			this.$router.push({name: 'm-characteristic'});
		} else {
			this.init();
		}
	},
	methods: {
		init() {
			this.$http.get('/api/website/getWorldFeatureInfo?platform=1').then((rsp) => {
				this.bannerList = rsp.result.worldFeature;
				this.interval();
			});
		},
		interval() {
			this.timeInterval = setInterval(() => {
				if(this.bannerList.length <= 1) {
					clearInterval(this.timeInterval);
				} else {
					if(this.numberChoose == this.bannerList.length-1) {
						this.numberChoose = 0;
					} else {
						this.numberChoose ++;
					}
				}
			}, 10000);
		},
		clearInterval() {
			clearInterval(this.timeInterval);
		},
		goPreview() {
			if(this.numberChoose == 0) {
				this.numberChoose = this.bannerList.length - 1;
			} else {
				this.numberChoose --;
			}
		},
		goNext() {
			if(this.numberChoose + 1 >= this.bannerList.length) {
				this.numberChoose = 0;
			} else {
				this.numberChoose ++;
			}
		}
	},
	beforeDestroy() {
		this.clearInterval();
	}
}
</script>